var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.58 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M33.6,13.32H27.31V9.26a7,7,0,1,0-14,0v4.06H7a1,1,0,0,0-1,1V36.23a1,1,0,0,0,1,1H33.6a1,1,0,0,0,1-1V14.32A1,1,0,0,0,33.6,13.32Zm-18.3,0v-4a5,5,0,1,1,10,0v4.06h-10ZM32.6,35.23H8V15.32H32.6Z",
    transform: "translate(-6.01 -2.23)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M20.3,28.82a1,1,0,0,0,1-1V22.9a1,1,0,0,0-2,0v4.92A1,1,0,0,0,20.3,28.82Z",
    transform: "translate(-6.01 -2.23)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/security-icon.4971f50bd2c2f8d374f8a379319191f3.svg";
export { ForwardRef as ReactComponent };